import { combineReducers } from 'redux'
import uiReducer from './uiReducer'
import entitiesReducer from './entitiesReducer'
import userLocationReducer from './userLocationReducer'
import tidesReducer from './tidesReducer'

const rootReducer = combineReducers({
  ui: uiReducer,
  entities: entitiesReducer,
  userLocation: userLocationReducer,
  tidesByStationId: tidesReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js